const SUPPORTED_IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "gif", "webp"];
const SUPPORTED_VIDEO_EXTENSIONS = ["mp4", "mov", "webm"];
const SUPPORTED_AUDIO_EXTENSIONS = ["mp3", "wav", "ogg"];
const SUPPORTED_DOCUMENT_EXTENSIONS = ["pdf", "doc", "docx", "xls", "xlsx"];
const SUPPORTED_ARCHIVE_EXTENSIONS = ["zip", "rar", "7z", "tar", "gz"];

export function isSupportedImageExtension(ext: string) {
	return SUPPORTED_IMAGE_EXTENSIONS.includes(ext);
}
